"use client";

import { usePathname } from "next/navigation";
import { SITE_ORIGIN } from "@/lib/site-url";

export function StructuredData() {
  const pathname = usePathname();
  const baseUrl = SITE_ORIGIN;
  // Removed unused variable: currentUrl

  // Organization schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "CertLynx",
    url: baseUrl,
    logo: `${baseUrl}/logo.png`,
    sameAs: [
      "https://twitter.com/certlynx",
      "https://facebook.com/certlynx",
      "https://instagram.com/certlynx",
    ],
    // Contact is exposed via a real page rather than a placeholder phone number.
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer service",
      url: `${baseUrl}/contact`,
      availableLanguage: ["English", "Spanish"],
    },
  };

  // Website schema. No SearchAction: the site has no public /search endpoint,
  // and advertising a broken one only produces Search Console errors.
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    url: baseUrl,
    name: "CertLynx",
    description:
      "CertLynx is a certification study community for people preparing for professional exams, licenses, and credentials.",
  };

  const segments = pathname.split("/").filter(Boolean);
  const isResourceArticle = segments[0] === "resources" && segments.length > 1;

  // Resource articles emit their own Home → Resources → article breadcrumb.
  const breadcrumbSchema = isResourceArticle
    ? null
    : {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: baseUrl,
      },
      ...(pathname !== "/"
        ? [
            {
              "@type": "ListItem",
              position: 2,
              name:
                segments[0]?.charAt(0).toUpperCase() +
                  (segments[0]?.slice(1) || "") || "",
              item: `${baseUrl}/${segments[0]}`,
            },
          ]
        : []),
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      {breadcrumbSchema && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />
      )}
    </>
  );
}
